import { MDBRow, MDBCol, MDBTypography, MDBCard } from "mdb-react-ui-kit";
import React from "react";
import Button from "@mui/material/Button";
import { Helmet } from "react-helmet";

import "~/src/components/blog/blog.css";

import { useParams } from "react-router-dom";
import EmbeddedBlock from "~/src/components/blog/blocks";
import { buttonStyleSX } from "../../components/base/containerComponents/styles.jsx";
import Sticky from "react-stickynode";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share";
import { SocialIcon } from "react-social-icons";
import Colors from "../../components/colors.jsx";
import { Grid } from "@mui/material";

const BLOG_ENDPOINT = process.env.BLOG_ENDPOINT;

function BlogPost() {
  const [content, setContent] = React.useState(null);
  const [randomTiles, setRandomTiles] = React.useState([]);
  const params = useParams();

  React.useEffect(() => {
    fetch(
      BLOG_ENDPOINT +
        "/posts?slug=" +
        params.slug +
        "&type=blog.BlogPage&fields=date,body,tags,meta_description,intro,meta_image"
    )
      .then((response) => response.json())
      .then((data) => {
        setContent(data.items[0]);
      });

    fetch(
      BLOG_ENDPOINT + "/posts?type=blog.BlogPage&fields=date,intro,meta_image"
    )
      .then((response) => response.json())
      .then((data) => {
        // select 3 random tiles
        const localRandomTiles = [];
        for (let i = 0; i < 3; i++) {
          const randomIndex = Math.floor(Math.random() * data.items.length);
          localRandomTiles.push(data.items[randomIndex]);
        }
        setRandomTiles(localRandomTiles);
      })
      .catch((error) => {
        console.error("Error fetching data from blog endpoint...", error);
      });
  }, []);

  if (!content) return null;

  const wordLength = getContentWordLength(content.body);
  return (
    <>
      <MDBRow>
        <Helmet>
          <title>{`${content.title} | FlatHub`}</title>
          <meta name="description" content={content.meta_description} />
          <meta name="keywords" content={content.tags.join(", ")} />
          <link
            rel="canonical"
            href={`https://flathub.pl${process.env.PREFIX}/pl/blog/${params.slug}`}
          />
          <meta property="og:title" content={content.title} />
          <meta property="og:description" content={content.meta_description} />
          <meta property="og:image" content={content.image} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="article" />
          <meta
            property="og:site_name"
            content="Najlepsze źródło wiedzy dla wynajmujących i kupujących nieruchomości"
          />
          <meta property="og:locale" content="pl_PL" />
        </Helmet>

        <div id="blog-post-header">
          <h1
            className="my-3 text-center"
            style={{ fontWeight: "bold", fontSize: "3.25rem" }}
          >
            {content.title}
          </h1>
          <MDBTypography
            component="p"
            variant="h5"
            className="my-3 text-center"
            style={{ fontWeight: "200", fontSize: "1.5rem", color: "gray" }}
          >
            {content.date}&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;
            {getReadingTime(wordLength)} min. czytania
          </MDBTypography>
        </div>

        <MDBCol
          className="d-flex flex-column col-md-10 col-12 mx-auto"
          id="blog-post-content"
        >
          <img
            src={content.meta_image}
            alt={content.title}
            style={{ maxWidth: "920px" }}
            className="img-fluid mx-auto"
          />
          <MDBTypography
            className="mt-3 pt-3"
            style={{
              maxWidth: "920px",
              margin: "0 auto",
              fontSize: "1.25rem",
              textAlign: "justify",
            }}
          >
            {content.body.map((block, index) => (
              <EmbeddedBlock key={block.index} block={block} />
            ))}
          </MDBTypography>
        </MDBCol>
        <MDBCol
          className="d-flex col-md-2 col-12 mx-auto"
          style={{ marginTop: "2rem" }}
        >
          <Sticky
            enabled={true}
            top="#blog-post-header"
            bottomBoundary="#blog-post-content"
          >
            <ShareButtons intro={content.intro} title={content.title} />
          </Sticky>
        </MDBCol>
      </MDBRow>
      <MDBRow id="blog-ending">
        <div className="d-flex flex-column mb-3">
          <MDBTypography
            className="mt-3 text-center"
            style={{ fontWeight: "bold", fontSize: "2.25rem" }}
          >
            Dowiedz się więcej z FlatHub
          </MDBTypography>
          <Button
            href="https://flathub.pl/invest"
            className="mx-auto mb-3"
            variant="contained"
            style={{ ...buttonStyleSX, fontSize: "1.5rem" }}
          >
            WCZESNY DOSTĘP
          </Button>
        </div>
        <hr />
        <MDBTypography
          className="my-3 text-center"
          style={{ fontWeight: "bolder", fontSize: "2rem" }}
        >
          Czytaj również
        </MDBTypography>
        <Grid container spacing={0}>
          {randomTiles.map((tile, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
              <BlogPostSuggestionTile tile={tile} />
            </Grid>
          ))}
        </Grid>
      </MDBRow>
    </>
  );
}

function ShareButtons(props) {
  const params = useParams();
  const url = `/blog_s/${params.slug}.html`;
  const intro = props.intro || "";
  const title = props.title || "";

  return (
    <div>
      <div
        className="d-flex flex-md-column flex-row justify-content-center"
        style={{ fontSize: "2rem", gap: "1rem" }}
      >
        {/* FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton */}
        <FacebookShareButton url={url} quote={intro}>
          <SocialIcon network="facebook" bgcolor={Colors.FlatHubGreen} />
        </FacebookShareButton>
        <TwitterShareButton
          url={url}
          title={title}
          hashtags={["nieruchomosci"]}
        >
          <SocialIcon network="twitter" bgcolor={Colors.FlatHubGreen} />
        </TwitterShareButton>
        <LinkedinShareButton url={url} summary={intro} title={title}>
          <SocialIcon network="linkedin" bgcolor={Colors.FlatHubGreen} />
        </LinkedinShareButton>
        <EmailShareButton url={url}>
          <SocialIcon network="email" bgcolor={Colors.FlatHubGreen} />
        </EmailShareButton>
      </div>
    </div>
  );
}

function BlogPostSuggestionTile({ tile }) {
  return (
    <MDBCol className="d-flex flex-column mx-auto">
      <a
        href={`${tile.meta.slug}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <MDBCard className="mb-3 hover-shadow">
          <img className="card-img-top border-bottom" src={tile.meta_image} />
          <div className="card-body">
            <h5 className="card-title">{tile.title}</h5>
            <p className="card-text">{tile.intro}</p>
          </div>
        </MDBCard>
      </a>
    </MDBCol>
  );
}

function getReadingTime(textLength) {
  const wordsPerMinute = 180;
  const minutes = Math.ceil(textLength / wordsPerMinute);
  return minutes;
}

function getContentWordLength(content) {
  let wordCount = 0;
  content.forEach((block, index) => {
    if (block.type === "paragraph") {
      wordCount += block.value.split(" ").length;
    }
  });
  return wordCount;
}

export default BlogPost;
